// components/admin/content-management/sections/index.js

import ButtonAddSection from './button/button-add-section.component.jsx';
import ContactFormAddSection from './contact-form/contact-form-add-section.component.jsx';
import DividerSection from './divider/divider-add-section.component.jsx';
import ImageSection from './image/image-add-section.component.jsx';
import ParagraphSection from './sections/paragraph-section.component.jsx';
import SpacerSection from './spacer/spacer-add-section.component.jsx';
import SubtitleSection from './sections/subtitle-section.component.jsx';
import TitleSection from './sections/title-section.component.jsx';
import YouTubeSection from './sections/youtube-add-section.component.jsx';
import ProductSlideshowAddSection from './product-slideshow/product-slideshow-add-section.component.jsx';

const sectionComponentMap = {
  button: {
    component: ButtonAddSection,
    name: 'Button',
    requires: { shop: false }
  },
  contactForm: {
    component: ContactFormAddSection,
    name: 'Contact Form',
    requires: { shop: false }
  },
  divider: {
    component: DividerSection,
    name: 'Divider',
    requires: { shop: false }
  },
  image: {
    component: ImageSection,
    name: 'Image',
    requires: { shop: false }
  },
  paragraph: {
    component: ParagraphSection,
    name: 'Paragraph',
    requires: { shop: false }
  },
  productSlideshow: {
    component: ProductSlideshowAddSection,
    name: 'Product Slideshow',
    requires: { shop: true }
  },
  spacer: {
    component: SpacerSection,
    name: 'Spacer',
    requires: { shop: false }
  },
  subtitle: {
    component: SubtitleSection,
    name: 'Subtitle',
    requires: { shop: false }
  },
  title: {
    component: TitleSection,
    name: 'Title',
    requires: { shop: false }
  },
  youtube: {
    component: YouTubeSection,
    name: 'YouTube Embed',
    requires: { shop: false }
  }
};

export default sectionComponentMap;